import { useCallback, useMemo } from 'react';
import { GameType } from '../../components/Games/games.model';
import { getGameUrl } from '../../components/Games/helper';
import { resolveGameDetailsBasePath } from '../../utils/games/gameDetailsBasePath';
import { AvailableBrands } from '../../components/Itv/types';

type BuildGameDetailsUrl = (slug: string, playType?: 'demo' | 'real', options?: { gameType?: GameType }) => string;

/**
 * Resolves the correct base path for the current route/brand and returns a helper
 * to build game detail URLs (including play type) without repeating the plumbing.
 */
export const useGameDetailsUrl = (
  brand: AvailableBrands,
  gameType?: GameType
): { basePath: string; buildGameDetailsUrl: BuildGameDetailsUrl } => {
  const { basePath } = useMemo(() => resolveGameDetailsBasePath(brand, gameType), [brand, gameType]);

  const buildGameDetailsUrl = useCallback(
    (slug: string, playType?: 'demo' | 'real', options?: { gameType?: GameType }) =>
      getGameUrl(slug, playType, { basePath, gameType: options?.gameType ?? gameType }),
    [basePath, gameType]
  );

  return { basePath, buildGameDetailsUrl };
};
